// src/components/Footer.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faCalendarCheck } from '@fortawesome/free-solid-svg-icons';
import { BOOKING_URL } from '../data/content';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <p className="text-white text-lg font-bold">Golden Coast Software Development</p>
          <p className="mt-3 text-sm leading-relaxed">
            Custom apps, websites, and software, built locally by Berkeley-trained engineers.
          </p>
        </div>

        <div>
          <p className="text-white font-semibold mb-3">Explore</p>
          <ul className="space-y-2 text-sm">
            <li><a href="/#services" className="hover:text-white transition">Services</a></li>
            <li><a href="/#recently-completed-projects" className="hover:text-white transition">Our Work</a></li>
            <li><a href="/#faq" className="hover:text-white transition">FAQ</a></li>
            <li><a href="/contact#what-to-expect" className="hover:text-white transition">What to Expect</a></li>
          </ul>
        </div>

        <div>
          <p className="text-white font-semibold mb-3">Get in Touch</p>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-2">
              <FontAwesomeIcon icon={faMapMarkerAlt} className="text-blue-400" />
              Southern California
            </li>
            <li>
              <a
                href={BOOKING_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 hover:text-white transition"
              >
                <FontAwesomeIcon icon={faCalendarCheck} className="text-blue-400" />
                Book a free consultation
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-gray-800 py-4 text-center text-sm text-gray-500">
        &copy; {new Date().getFullYear()} Golden Coast Software Development. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
